import { useState } from "react"

// TODO: 汎用的な component にする
import * as HoverCard from "@radix-ui/react-hover-card"

const tooltipStyle: React.CSSProperties = {
	backgroundColor: "#333",
	color: "#fff",
	padding: "8px 12px",
	borderRadius: "6px",
	fontSize: "12px",
	lineHeight: "1.5",
	maxWidth: "280px",
	zIndex: 100,
	boxShadow: "0 2px 8px rgba(0,0,0,0.2)",
}

type TooltipIconProps = {
	content: string
}

export const TooltipIcon = ({ content }: TooltipIconProps) => {
	const [open, setOpen] = useState(false)

	return (
		<HoverCard.Root open={open} onOpenChange={setOpen} openDelay={300}>
			<HoverCard.Trigger asChild>
				<span
					style={{
						cursor: "help",
						color: "#9e9e9e",
						fontSize: "12px",
						marginLeft: "4px",
					}}
				>
					?
				</span>
			</HoverCard.Trigger>
			<HoverCard.Portal>
				<HoverCard.Content sideOffset={5} style={tooltipStyle}>
					{content}
				</HoverCard.Content>
			</HoverCard.Portal>
		</HoverCard.Root>
	)
}

/** 未確定 rereservation の警告アイコン + ホバーカード */
type UnconfirmedWarningProps = {
	count?: number
}

const warningCardStyle: React.CSSProperties = {
	backgroundColor: "#fff",
	padding: "12px 16px",
	borderRadius: "8px",
	border: "1px solid #e0e0e0",
	maxWidth: "340px",
	zIndex: 100,
	boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
}

export const UnconfirmedWarningTooltip = ({
	count,
}: UnconfirmedWarningProps) => {
	const [open, setOpen] = useState(false)
	const displayCount = count ?? 0

	return (
		<HoverCard.Root open={open} onOpenChange={setOpen} openDelay={300}>
			<HoverCard.Trigger asChild>
				<span
					style={{
						cursor: "help",
						color: "#f59e0b",
						fontSize: "16px",
						fontWeight: 700,
						display: "inline-flex",
						alignItems: "center",
						justifyContent: "center",
						width: "28px",
						height: "28px",
					}}
				>
					&#9888;
				</span>
			</HoverCard.Trigger>
			<HoverCard.Portal>
				<HoverCard.Content sideOffset={5} style={warningCardStyle}>
					<div
						style={{
							display: "flex",
							alignItems: "center",
							gap: "6px",
							marginBottom: "8px",
						}}
					>
						<span
							style={{ color: "#f59e0b", fontSize: "14px", fontWeight: 700 }}
						>
							&#9888;
						</span>
						<span style={{ fontSize: "13px", fontWeight: 700, color: "#333" }}>
							再予約未確定{displayCount > 0 ? `: ${displayCount}件` : ""}
						</span>
					</div>
					<div
						style={{ fontSize: "12px", color: "#958484", lineHeight: "1.6" }}
					>
						ステータスが確定していない再予約があります。
						<br />
						相殺明細のハンバーガーメニューから
						<br />
						「再予約ステータス修正」で確定してください。
					</div>
				</HoverCard.Content>
			</HoverCard.Portal>
		</HoverCard.Root>
	)
}
